import Vue from "vue";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { InfinityCurve } from "./InfinityCurve";
import { goldMaterial } from "./SweepBuilder";
import { HeartCurve } from "./Heart";
export default Vue.extend({
    data() {
        return {
            scene: null,
            camera: null,
            renderer: null,
            controls: null,
            profileWidth: 1.2,
            profileHeight: 0.8,
            concaveDepth: -1.1,
            topMesh: null,
            urls: [
                "/img/pisa/px.png",
                "/img/pisa/nx.png",
                "/img/pisa/py.png",
                "/img/pisa/ny.png",
                "/img/pisa/pz.png",
                "/img/pisa/nz.png",
            ],
        };
    },
    mounted() {
        this.init3D();
        this.drawProfile2D();
        this.animate();
    },
    watch: {
        profileWidth() {
            this.drawProfile2D();
        },
        profileHeight() {
            this.drawProfile2D();
        },
        concaveDepth() {
            this.drawProfile2D();
        },
    },
    methods: {
        init3D() {
            // Szene + Kamera
            this.scene = new THREE.Scene();
            this.camera = new THREE.PerspectiveCamera(45, 500 / 500, 0.1, 1000);
            this.camera.position.set(0, 0, 50);
            this.camera.lookAt(0, 0, 0);
            // Renderer
            this.renderer = new THREE.WebGLRenderer({ antialias: true });
            this.renderer.setSize(960, 720);
            this.$refs.canvas3d.appendChild(this.renderer.domElement);
            const background = new THREE.CubeTextureLoader().load(this.urls);
            this.scene.background = background;
            // Licht
            const ambient = new THREE.AmbientLight(0xffffff, 0.5);
            this.scene.add(ambient);
            const dir = new THREE.DirectionalLight(0xffffff, 0.8);
            dir.position.set(10, 10, 10);
            this.scene.add(dir);
            // Controls
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            // Initiales 3D-Profil
            this.updateProfile3D();
        },
        drawProfile2D() {
            const canvas = this.$refs.profileCanvas;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            // Transformieren in Canvas-Koordinaten
            const cx = canvas.width / 2;
            const cy = canvas.height / 2;
            const scale = 50; // 1 mm = 50 px
            ctx.strokeStyle = "red";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(cx - this.profileWidth * scale, cy);
            ctx.quadraticCurveTo(cx - this.profileWidth * scale, cy - this.profileHeight * scale, cx, cy - this.profileHeight * scale);
            ctx.quadraticCurveTo(cx + this.profileWidth * scale, cy - this.profileHeight * scale, cx + this.profileWidth * scale, cy);
            // Unterseite konkav
            ctx.quadraticCurveTo(cx, cy + this.concaveDepth * scale, cx - this.profileWidth * scale, cy);
            ctx.closePath();
            ctx.stroke();
        },
        updateProfile3D() {
            if (!this.scene)
                return;
            if (this.topMesh) {
                this.scene.remove(this.topMesh);
            }
            // 3D-Profil
            const profile = new THREE.Shape();
            profile.moveTo(-this.profileWidth, 0);
            profile.lineTo(-this.profileWidth, this.profileHeight);
            profile.lineTo(this.profileWidth, this.profileHeight);
            profile.lineTo(this.profileWidth, 0);
            //   profile.quadraticCurveTo(
            //     -this.profileWidth,
            //     this.profileHeight,
            //     0,
            //     this.profileHeight
            //   );
            //   profile.quadraticCurveTo(
            //     this.profileWidth,
            //     this.profileHeight,
            //     this.profileWidth,
            //     0
            //   );
            //   profile.quadraticCurveTo(0, -this.concaveDepth, -this.profileWidth, 0);
            profile.closePath();
            const curve = new InfinityCurve(28, 0.7); // mm
            const extrudeSettings = {
                steps: 500,
                bevelEnabled: true,
                extrudePath: curve,
            };
            const geometry = new THREE.ExtrudeGeometry(profile, extrudeSettings);
            this.topMesh = new THREE.Mesh(geometry, goldMaterial);
            this.scene.add(this.topMesh);
            const geo = new THREE.ExtrudeGeometry(profile, {
                steps: 300,
                bevelEnabled: false,
                extrudePath: new HeartCurve(0.8),
            });
            const m = new THREE.Mesh(geo, goldMaterial);
            m.translateX(20);
            m.translateY(-13);
            m.translateZ(-2.6);
            m.rotateY(1);
            this.scene.add(m);
            const geo1 = new THREE.ExtrudeGeometry(profile, {
                steps: 300,
                bevelEnabled: false,
                extrudePath: new HeartCurve(0.8),
            });
            const m1 = new THREE.Mesh(geo1, goldMaterial);
            m1.translateX(-20);
            m1.translateY(-13);
            m1.translateZ(-2.6);
            m1.rotateY(-1);
            this.scene.add(m1);
        },
        animate() {
            requestAnimationFrame(() => this.animate());
            if (this.controls && this.renderer && this.scene && this.camera) {
                this.controls.update();
                this.renderer.render(this.scene, this.camera);
            }
        },
    },
});
